import { render } from "./DeliverView.vue?vue&type=template&id=40582edc&scoped=true"
import script from "./DeliverView.vue?vue&type=script&lang=js"
export * from "./DeliverView.vue?vue&type=script&lang=js"

import "./DeliverView.vue?vue&type=style&index=0&id=40582edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40582edc"]])

export default __exports__